export function OformlenieController(uchetService) {
  const vm = this

  vm.pid = $.fn.urlparam('pid')
  vm.fid = $.fn.urlparam('fid')
  vm.val = $.fn.urlparam('val')
}
